// src/types/models.ts (or a similar shared types file)
export interface AIModel {
  id: string; // e.g., 'gemini-2.5-pro', 'claude-3-opus'
  name: string; // e.g., "2.5 Pro (preview)"
  shortName?: string; // e.g., "2.5 Pro" (for display in the trigger button)
  description?: string;
  isNew?: boolean;
  isPreview?: boolean;
  // Add any other properties relevant to a model
}

// Sample model data - move this to a config file or fetch from backend later
export const availableAIModels: AIModel[] = [
  { id: 'webelieve-pro-v1', name: 'WeBelieve Pro V1', shortName: 'Pro V1', description: 'Balanced performance and reasoning.', isPreview: true },
  { id: 'webelieve-flash-v1', name: 'WeBelieve Flash V1', shortName: 'Flash V1', description: 'Fastest for quick tasks.', isNew: true },
  { id: 'webelieve-max-v1', name: 'WeBelieve Max V1 (experimental)', shortName: 'Max V1', description: 'Advanced reasoning, slower.', isPreview: true },
];
// src/types/models.ts (or a new file like src/types/appData.ts)

// New interfaces
export interface ChatSession {
  id: string; // Will be MongoDB _id
  projectId?: string | null; // Optional: if chat is part of a project
  title: string; // e.g., first few words of user query, or user-defined
  createdAt: Date;
  updatedAt: Date;
  // lastMessageSnippet?: string; // For display in lists
  // messageCount?: number;
  // Potentially some summary or key entities
}

export interface Project {
  id: string; // Will be MongoDB _id
  name: string;
  createdAt: Date;
  updatedAt: Date;
  description?: string; // Optional
  // We can add 'chatSessionIds: string[]' and 'documentIds: string[]' later
}

// For the waffle menu applications
export interface AppDefinition {
  id: string;
  name: string;
  icon: React.ElementType; // e.g., Heroicon component
  // action?: () => void; // For MVP, or later for navigation/dispatch
}